import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';
import { Stock } from './stock.model';

export class DeclarationStock {
    static jsonMap = {
        idRefCampagne: { key: 'idRefCampagne', optional: true },
        idEntreprise: { key: 'idEntreprise', optional: true },
        numMois: { key: 'numMois', optional: true },
        stocks: { key: 'stocks', converter: new (ArrayClassConverterFactory.build(Stock))(), optional: true, default: () => [] }
    };

    public idRefCampagne: number;
    public idEntreprise: number;
    public numMois: number;
    public stocks: Stock[];
}
